<div class="backdrop" (click)="close.emit()"></div>

<div class="dialog" role="dialog" aria-modal="true">
  <div class="dialog__body">
    <div class="dialog__left">
      <div class="dialog__photo">
        <img [src]="imageSrc" alt="" [class.no-photo]="!entry.item.image" />
        <app-label-banners class="dialog__labels" [labels]="entry.item.labels"></app-label-banners>
      </div>

      <div class="nutrition" *ngIf="nutrition.length">
        <div class="nutrition__title">
          {{ 'energy' | translate }},
          {{ entry.item.energy ? ('per100' | translate) + ' ' + unit : ('perServing' | translate) }}
        </div>
        <div class="nutrition__row">
          <div *ngFor="let n of nutrition"><b>{{ n.value }}</b><span>{{ n.key | translate }}</span></div>
        </div>
      </div>
    </div>

    <div class="dialog__right">
      <!-- Название, описание, цена и варианты — всегда на виду -->
      <div class="dialog__head">
        <button class="close" (click)="close.emit()" aria-label="✕">
          <svg viewBox="0 0 24 24" width="20" height="20"><path d="M6 6l12 12M18 6 6 18" /></svg>
        </button>

        <div class="crumb" *ngIf="category">{{ category | titleTranslate }}</div>
        <h1 class="title">{{ entry.item | fieldTranslate: 'title' }}</h1>
        <p class="description">{{ entry.item | fieldTranslate: 'description' }}</p>

        <div class="price">
          <b *ngIf="price | priceSeparator as p">{{ p.whole }}{{ p.separator }}{{ p.fraction }} {{ currency }}</b>
          <span>
            <ng-container *ngIf="size">{{ size }} {{ unit }}</ng-container>
            <ng-container *ngIf="strength"><ng-container *ngIf="size"> · </ng-container>{{ strength }}%</ng-container>
            <ng-container *ngIf="entry.item.prepare"><ng-container *ngIf="size || strength"> · </ng-container>{{ entry.item.prepare }} {{ time }}</ng-container>
          </span>
        </div>

        <div class="variants" *ngIf="variants.length > 1">
          <button *ngFor="let variant of variants; let i = index" [class.on]="i === choice" (click)="choice = i">
            {{ variant.title }}
            <small *ngIf="(variant.price ?? entry.item.price) | priceSeparator as p">{{ p.whole }}{{ p.separator }}{{ p.fraction }} {{ currency }}</small>
          </button>
        </div>
      </div>

      <!-- Аллергены, добавки и рекомендации прокручиваются, шапка остаётся на месте -->
      <div class="dialog__scroll">
        <app-allergen-list class="allergens" [allergens]="entry.item.allergens"></app-allergen-list>

        <ng-container *ngIf="modificators as mods">
          <!-- Неактивная группа — без названия (как «Добавить» в мобильной) -->
          <h4 *ngIf="mods.active; else untitled">{{ mods | titleTranslate }}<small>{{ 'addAtOrder' | translate }}</small></h4>
          <ng-template #untitled><h4 class="capitalized">{{ 'addAtOrder' | translate }}</h4></ng-template>
          <div class="mods">
            <div class="mod" *ngFor="let mod of mods.items">
              <div class="mod__image"><app-lazy-image [imageUrl]="mod.image" [kind]="entry.kind"></app-lazy-image></div>
              <b>{{ mod | titleTranslate }}</b>
              <span class="mod__price">
                <ng-container *ngIf="mod.price | priceSeparator as p">+{{ p.whole }}{{ p.separator }}{{ p.fraction }} {{ currency }}</ng-container>
                <app-allergen-pill [allergens]="mod.allergens || []" [plain]="true" [max]="2" [size]="14"></app-allergen-pill>
              </span>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="recommendations.length">
          <h4>{{ 'together' | translate }}</h4>
          <div class="recs">
            <button class="rec" *ngFor="let rec of recommendations" (click)="select.emit(rec)">
              <span class="rec__image"><app-lazy-image [imageUrl]="rec.item.image" [kind]="rec.kind"></app-lazy-image></span>
              <span>
                <b>{{ rec.item | fieldTranslate: 'title' }}</b>
                <span *ngIf="rec.item.price | priceSeparator as p">
                  <ng-container *ngIf="rec.item.variability">{{ 'from' | translate }} </ng-container>{{ p.whole }}{{ p.separator }}{{ p.fraction }} {{ currency }}
                </span>
              </span>
            </button>
          </div>
        </ng-container>
      </div>
    </div>
  </div>

  <div class="dialog__footer">
    <span class="qr">
      <svg viewBox="0 0 24 24" width="18" height="18"><rect x="3" y="3" width="7" height="7" rx="1.5" /><rect x="14" y="3" width="7" height="7" rx="1.5" /><rect x="3" y="14" width="7" height="7" rx="1.5" /><path d="M14 14h3v3h-3zM20 14v.01M14 20h.01M17 20h4v-3" /></svg>
    </span>
    <span><b>{{ 'orderAtVenue' | translate }}</b> {{ 'orderAtVenueHint' | translate }}</span>
    <button class="share" (click)="copyLink.emit()">
      <svg viewBox="0 0 24 24" width="18" height="18"><path d="M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1" /><path d="M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1" /></svg>
      {{ (linkCopied ? 'linkCopied' : 'itemLink') | translate }}
    </button>
  </div>
</div>
